import {createContext, useContext} from 'solid-js';
import {OKXConnectUI} from "../okx-connect-ui.interface";

export const OKXConnectUiContext = createContext<OKXConnectUI>();

// export const TONConnectUiContext = createContext<OKXTonConnectUI>();
// export const UniversalConnectUiContext = createContext<OKXUniversalConnectUI>();
